<template>
  <div class="container">
    <div id="app">
      <header v-if="header">
        <h1 class="title">
          Моніторинг наявності препаратів для лікування вірусних гепатитів С та В для дорослих та дітей
        </h1>
      </header>

      <section v-if="header" class="content description subheader">
        <p>3,6% населення України хворі на гепатит С, ще 1,5% —  на гепатит В. За відсутності лікування ці хвороби можуть призвести до цирозу та раку печінки. Українці з таким діагнозом мають право на безкоштовне лікування. Як дізнатися, де можна стати на облік і знайти потрібні ліки? </p>
        <p>Саме на ці питання відповідає проєкт ТЕКСТІВ «Моніторинг наявності препаратів для лікування вірусних гепатитів С та В для дорослих та дітей». З 2013 року препарати  для профілактики та лікування гепатиту централізовано закуповуються за кошти державного бюджету. І завдяки міжнародним партнерам за останні кілька років цей процес став абсолютно прозорим. Обласні лікарні отримують препарати з ДЦ “Укрвакцина” та перерозподіляють їх на районний рівень. Тобто навіть у найменшому та найвіддаленішому населеному пункті України є доступ до препаратів від гепатиту.</p>
        <p>Український уряд взяв на себе зобов’язання до 2030 року вилікувати більше 90% пацієнтів. Однак найбільша проблема полягає в тому, що хворі не звертаються за допомогою: симптоми відчуваються лише на пізніх стадіях, масове тестування для виявлення хвороби не проводиться. Хоча це вкрай важливо для попередження поширення гепатиту. Люди часто навіть не підозрюють про наявність у себе гепатиту і передають хворобу іншим. А коли дізнаються про свій діагноз, вже мають з десяток контактних осіб. </p>
        <p>Вірусний гепатит відноситься до соціально-небезпечних хвороб та здебільшого розповсюджується серед вразливих груп населення: працівників комерційного сексу, споживачів ін’єкційних наркотиків та безпритульних, проте захворіти може кожен. </p>  
      </section>

      <section class="content main-grid">
        <search
          placeholder="Почніть вводити назву препарату ..."
          :search_index="medicine_index"
          @term_selected="
            (term) => {
              selected_medicine = medicine_map.get(term);
            }
          "
        />

        <div class="filter-buttons">
          <button
            :class="`${filter_active === 'facility' ? 'active' : ''}`"
            @click="() => (filter_active = 'facility')"
          >
            Медзаклад
          </button>
          <button
            :class="`${filter_active === 'region' ? 'active' : ''}`"
            @click="() => (filter_active = 'region')"
          >
            Область
          </button>
          <div
            class="help"
            @mouseover="() => (help_showed = true)"
            @mouseout="() => (help_showed = false)"
          >
            <span> ? </span>

            <how-to-use v-if="help_showed" />
          </div>
        </div>
        <div class="map-container">
          <main-map
            class="main-map"
            :points="dataset"
            v-if="dataset"
            @point_selected="point_selected"
            :region="selected_region ? selected_region.region : null"
          />
        </div>

        <div class="infopane" v-if="filter_active === 'facility'">
          <div v-if="!selected_point" class="default-pane">
            <p>
              Оберіть точку на карті, щоб побачити детальну інформацію про
              наявність препаратів
            </p>
          </div>
          <info-card v-else :f="selected_point" :config="config" />
        </div>

        <div class="infopane" v-else>
          <region-select
            :regions="regions_data"
            @change="
              (r) => {
                selected_region = r;
                if (selected_point) selected_point.selected = false;
                selected_point = null;
              }
            "
          />
          <region-info-card
            v-if="selected_region"
            :r="selected_region"
            :config="config"
            :orders_map="orders_map"
          />
        </div>
      </section>
    </div>
    <about />
    <footer-footer />
  </div>
</template>

<script>
import MainMap from "./components/MainMap";
import InfoCard from "./components/InfoCard";
import RegionInfoCard from "./components/RegionInfoCard";
import RegionSelect from "./components/RegionSelect.vue";
import Search from "./components/Search";
import FooterFooter from "./components/FooterFooter";
import About from "./components/About";
import HowToUse from "./components/HowToUse";

import * as d3 from "d3";
import * as d3_array from "d3-array";
import { last } from "./utils";
import * as _ from "./send_resize_msg";

function get_query_params() {
  return new URLSearchParams(window.location.search);
}

function inIframe () {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

export default {
  name: "App",
  components: {
    MainMap,
    InfoCard,
    RegionInfoCard,
    Search,
    RegionSelect,
    FooterFooter,
    About,
    HowToUse,
  },

  created() {
    // let params = get_query_params();
    // this.header = params.get("header");
    this.loadData();
  },

  data: function () {
    return {
      header: !inIframe(),
      filter_active: "facility",
      dataset: null,
      selected_point: null,
      config: null,
      medicine_map: null,
      medicine_index: null,
      selected_medicine: null,
      orders_map: null,

      regions_data: null,
      selected_region: null,
      help_showed: false,
    };
  },

  methods: {
    async loadData() {
      let [index, main_table, config, orders] = await Promise.all([
        d3.csv("data/index.csv"),
        d3.csv("data/main.csv"),
        d3.json("data/config.json"),
        d3.csv("data/orders.csv"),
      ]);

      this.config = config;
      let facility_metadata_by_name = new Map(
        index.map((r) => [r.facility_name, r])
      );

      // main_table.forEach(r => {
      //   r.month = r.endDate.substring(0,7)
      // })

      let facilities = Array.from(
        d3_array.group(main_table, (d) => d.facility_name),

        ([key, rows]) => {
          let reports = reports_from_rows(rows);

          return {
            facility_name: key,
            ...facility_metadata_by_name.get(key),
            reports: reports,
            last_r: last(reports),
            selected: false,
            tooltip: "",
          };
        }
      );
      this.dataset = facilities;
      console.log(facilities);

      let last_data = [];
      facilities.forEach((f) => {
        f.last_r.medicines.forEach((m) => last_data.push(...m.rows));
      });

      this.medicine_map = d3_array.group(last_data, (r) => r.medicine);
      this.medicine_index = Array.from(this.medicine_map, ([key, rows]) => ({
        medicine: key,
        text: key,
        rows: rows,
      }));

      this.orders_map = d3_array.group(
        orders,
        (r) => r.region,
        (r) => r.medicine
      );
      console.log(this.orders_map);

      let regions_data = Array.from(
        d3_array.group(facilities, (f) => f.region),

        ([key, rows]) => ({
          region: key,
          facilities: rows,
          aggregated_facility: aggregate_facilities(rows),
        })
      );

      this.regions_data = regions_data;
    },

    point_selected(p) {
      this.selected_point = p;
      this.filter_active = "facility";
      // this.selected_region = null;
    },
  },

  computed: {
    tooltips() {
      if (!this.selected_medicine) return null;
      return d3_array.rollup(
        this.selected_medicine,
        (v) => d3_array.sum(v, (o) => +o.unitBalanseEnd),
        (r) => r.facility_name
      );
    },
  },

  watch: {
    tooltips() {
      this.dataset.forEach((f) => {
        f.tooltip = this.tooltips
          ? this.tooltips.get(f.facility_name) || ""
          : null;
      });
    },

    filter_active(val) {
      if (val === "facility") {
        this.selected_region = null;
      }
    },
  },
};


function aggregate_facilities(facilities) {
  let last_reports = facilities.map((f) => f.last_r);
  let rows = [];

  last_reports.forEach((r) => r.medicines.forEach((m) => rows.push(...m.rows)));

  let medicines = medicines_from_rows(rows);

  let reports = [];
  facilities.forEach((f) => reports.push(...f.reports));

  return {
    last_r: {
      medicines: medicines,
    },
    reports: reports,
  };
}

function medicines_from_rows(rows) {
  return Array.from(
    d3_array.group(rows, (r) => r.medicine),
    ([key, rows]) => ({
      medicine: key,
      ...medicine_metadata_from_rows(rows),
      open: false,
      rows,
    })
  );
}

function reports_from_rows(rows) {
  return Array.from(
    d3_array.group(rows, (r) => r.month),
    ([key, rows]) => ({ month: key, medicines: medicines_from_rows(rows) })
  ).sort((a, b) => d3.ascending(a.month, b.month));
}

function medicine_metadata_from_rows(rows) {
  let r = rows[0];
  return { name: r.name, releaseForm: r.releaseForm, dosage: r.dosage };
}
</script>

<style lang="scss">
@import "./assets/_mixins.scss";

body {
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  margin: 0;
  padding: 0;
}

input {
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
}

body,
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --col-mainblue: #004188;
  --col-orange: #faa627;
  --col-grey: #f7f7f7;
  --col-main-grey: #aaa;
}

header {
  background: var(--col-mainblue);
  color: white;

  .title {
    font-size: 2em;
    font-weight: 600;
    text-transform: uppercase;

    max-width: 60rem;
    margin: 0 auto;
    padding: 0.5em 0;
  }

  margin-bottom: 1em;
}

.content {
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 1em;
}

.main-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  grid-row-gap: 1em;
  grid-column-gap: 2em;
}

@include for-mobile {
  .container {
    padding: 0 10px;
  }
  .main-grid {
    display: flex;
    flex-direction: column;
  }
  .search {
    min-height: 3em;
  }

  .main-map {
    min-height: unset !important;
    #leaflet-map {
      min-height: 35vh im !important;
    }
  }
}
.search {
  grid-row: 1;
  grid-column: 1;

  @include for-mobile {
  }
}

.filter-buttons {
  grid-row: 1;
  grid-column: 2;
}

.map-container {
  grid-row: 2;
  grid-column: 1;
}

.filter-buttons {
  display: flex;
  gap: 1em;

  position: relative;

  > * {
    border: none;
    border-radius: none;
    text-transform: uppercase;
    font-size: 1em;

    padding: 0.5em 1em;
    font-weight: 700;

    background: var(--col-grey);
    color: var(--col-orange);

    min-width: 10em;

    cursor: pointer;

    &.active {
      background: var(--col-orange);
      color: white;
    }
  }

  .help {
    min-width: unset;
    width: 2.6rem;
    border-radius: 50%;
    border: 1px solid var(--col-mainblue);
    margin-left: auto;
    color: var(--col-mainblue);
    right: 0;

    &:hover {
      color: white;
      border-color: white;

      background-color: var(--col-mainblue);
      cursor: help;
    }
  }
}

.light-text {
  color: var(--col-main-grey);
}

.search {
  border-radius: 0;
  border: none;
  background-color: var(--col-grey);
}

.infopane {
  width: 100%;
  padding-bottom: 2em;

  .default-pane {
    display: flex;
    align-items: center;
    background-color: var(--col-grey);
    width: 100%;
    height: 100%;
    padding: 0 1em;

    text-align: center;
  }

  p {
    color: var(--col-mainblue);
  }
}
</style>

<style lang="scss">
.subheader {
  margin-bottom: 4em;
  max-width: 60em;

  color: var(--col-mainblue);
  font-size: 1rem;

  p {
      margin-bottom: 0.8rem;
  }

}

.small-text {
  color: var(--col-main-grey);
  font-size: 0.8rem;
}

.region-select {
  margin-bottom: 1em;
}

.main-map {
  position: sticky;
  top: 0;
}
</style>
